import AttributesLoader from 'components/standard/PageLayout/AttributesLoader';
import hostingDetailsAlsowith from 'containers/pages/servers/details/hostingDetailsAlsowith';
import useAssetDetails from 'modules/queries/asset/useDetails';
import { useLatestNotifications } from 'modules/queries/notification/useCurrent';
import { useParams } from 'react-router';
import AttributesContent from './AttributesContent';

const Attributes = () => {
	const { uniqId } = useParams<{ uniqId: string }>();
	const { data, isLoading, isError } = useAssetDetails(
		{
			alsowith: hostingDetailsAlsowith,
			uniq_id: uniqId,
		},
		{ enabled: Boolean(uniqId) },
	);
	const { data: notifications, isLoading: isLoadingNotifications } =
		useLatestNotifications(
			{},
			{
				refetchInterval: 10000,
				enabled: Boolean(uniqId),
			},
		);

	if (isError) {
		return null;
	}

	if (isLoading || isLoadingNotifications) {
		return <AttributesLoader />;
	}

	return <AttributesContent {...data} notification={notifications?.[uniqId]} />;
};

export default Attributes;
